import { supabase } from '@/lib/supabase/client'
import { Match, NewMatch } from '@/types/admin'

export const MatchesService = {
  async getAll() {
    const { data, error } = await supabase
      .from('matches')
      .select('*, jobs(*), educators(*)')
      .order('created_at', { ascending: false })

    if (error) throw error
    return data as Match[]
  },

  async create(match: NewMatch) {
    const { data, error } = await supabase
      .from('matches')
      .insert(match)
      .select('*, jobs(*), educators(*)')
      .single()

    if (error) throw error
    return data as Match
  },

  async update(id: string, updates: Partial<Match>) {
    const { data, error } = await supabase
      .from('matches')
      .update(updates)
      .eq('id', id)
      .select('*, jobs(*), educators(*)')
      .single()

    if (error) throw error
    return data as Match
  },

  async delete(id: string) {
    const { error } = await supabase.from('matches').delete().eq('id', id)

    if (error) throw error
  },
}
